<div class="container-fluid body">
  <div class='row'>
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
